import { axiosi } from "../../config/axios"
import { db } from "../../firebase";
import { doc, getDoc, updateDoc , getFirestore } from "firebase/firestore";

// export const fetchLoggedInUserById=async(id)=>{
//     try {
//         const res=await axiosi.get(`/userss/${id}`)
//         return res.data
//     } catch (error) {
//         // throw error.response.data
//         return {
//             "_id": "65b8e564ea5ce114184ccb96",
//             "name": "demo user",
//             "email": "demo@gmail.com",
//             "isVerified": true,
//             "isAdmin": false,
//             "__v": 0
//         }
//     }
// }
// export const updateUserById=async(update)=>{
//     try {
//         const res=await axiosi.patch(`/users/${update._id}`,update)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

// export const fetchLoggedInUserById = async (id) => {
//     try {
//         const userRef = doc(db, "users", id);
//         const snap = await getDoc(userRef);

//         if (snap.exists()) {
//             return { _id: snap.id, ...snap.data() };
//         }

//     } catch (error) {
//         throw error.response.data
//     }
// };


export const fetchLoggedInUserById = async (id) => {
    try {
      const db = getFirestore();
      // Guest → guests collection
      if (id.startsWith("guest-")) {
        const ref = doc(db, "guests", id);
        const snap = await getDoc(ref);
        return snap.exists() ? snap.data() : null;
      }
  
      // Normal user
      const ref = doc(db, "users", id);
      const snap = await getDoc(ref);
      return snap.exists() ? { _id: snap.id, ...snap.data() } : null;
  
    } catch (error) {
      console.log("Fetch error:", error);
      return null;
    }
  };
  
  

export const updateUserById = async (update) => {
    try {
        const userRef = doc(db, "users", update._id);
        await updateDoc(userRef, update);

        return { success: true };
    } catch (error) {
        throw { message: error.message };
    }
};